import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const DiscAfricaProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="DISC Test Nigeria | DISC Assessment Online Lagos | DISC Lens Africa"
        description="Take the DISC Lens Africa™ assessment online. Nigeria's most comprehensive DISC behavioural test combining styles, values, and motivation. Get your personalised leadership report. Used by Nigerian executives and teams."
        keywords="DISC test Nigeria, DISC assessment online Lagos, DISC profile Nigeria, take DISC test Africa, DISC questionnaire Nigeria, behavioural test Lagos, DISC Lens Africa"
        canonical="https://impactasportal.com/product/disc-africa"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/disc-africa?embed=true"
            title="DISC Lens Africa™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default DiscAfricaProductPage;
